import { useEffect, useState } from 'react'
import { cn } from '@/common/utils/cn'

const AnimatedChar = ({ char }: { char: string }) => {
  const [state, setState] = useState<{ current: string; previous: string | null }>({
    current: char,
    previous: null,
  })

  useEffect(() => {
    setState((prev) => (prev.current === char ? prev : { current: char, previous: prev.current }))
  }, [char])

  useEffect(() => {
    if (state.previous === null) return
    const timeout = setTimeout(() => setState((prev) => ({ ...prev, previous: null })), 300)
    return () => clearTimeout(timeout)
  }, [state.previous, state.current])

  const animating = state.previous !== null
  const render = (value: string) => (value === ' ' ? ' ' : value)

  return (
    <span className="relative inline-block overflow-hidden leading-none">
      <span className={cn('block leading-none', animating && 'animate-countdown-in')}>
        {render(state.current)}
      </span>
      {animating && state.previous !== null && (
        <span className="absolute inset-0 block leading-none animate-countdown-out">
          {render(state.previous)}
        </span>
      )}
    </span>
  )
}

const AnimatedCountdown = ({ value, className }: { value: string; className?: string }) => (
  <span className={cn('inline-flex tabular-nums leading-none', className)}>
    {value.split('').map((char, index) => (
      <AnimatedChar key={index} char={char} />
    ))}
  </span>
)

export default AnimatedCountdown
